import { render } from "./Tabpanel.vue?vue&type=template&id=61b84287&scoped=true"
import script from "./Tabpanel.vue?vue&type=script&lang=js"
export * from "./Tabpanel.vue?vue&type=script&lang=js"

import "./Tabpanel.vue?vue&type=style&index=0&id=61b84287&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b84287"]])

export default __exports__